




































import { Component, Vue } from 'vue-property-decorator';
import PerformanceCard from '@/components/organizationDashboard/performance/PerformanceCard.vue';
import MemberDetailModal from '@/components/organizationDashboard/modals/MemberDetailModal.vue';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';

@Component({
  components: {
    PerformanceCard,
    MemberDetailModal,
    OrganizationIcon
  },
})
export default class PerformanceBase extends Vue {
  private isOpenMemberDetailModal: boolean = false;
  private hideShowButton: null = null;
  private model: boolean = false;
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#fdb44d';

  private closeMemberDetailModal(): void {
    this.isOpenMemberDetailModal = false;
  }
}
